// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/bundle." + {"4":"a4a167dbab4030931b36","826":"b9b3a52e546ffa4a980f"}[chunkId] + ".css";
};